<template>
  <PageContentLayoutOnly>
    <ModernTable :filters="filters" :rows="notesList" :columns="columns" :pagination="pagination">
      <template v-slot:header>
        <div class="pb-5">
          <b-button @click="createNoteModal()" size="is-small" type="is-primary" rounded>
            Create Note
          </b-button>
          <b-button
            type="is-ghost"
            @click="toggleFilters"
            :style="styles.filterButton"
            :class="'filter-button ' + (filters.show ? 'active' : '')"
          >
            <b-icon pack="mdi" icon="filter-outline" size="is-small" style="display: inline-block">
            </b-icon>
            <div style="display: inline-block">Filter</div>
          </b-button>
        </div>
      </template>
    </ModernTable>
    <Modal :toggle.sync="noteToggle">
      <NotesModal :workOrderID="parseInt(workOrderID)" :workOrderNote="selectedNote" />
    </Modal>
  </PageContentLayoutOnly>
</template>

<script>
import { mapState } from 'vuex'
import PageContentLayoutOnly from '@/containers/PageContentLayoutOnly'
import ModernTable from '@/components/tables/Modern/Table'
import NotesModal from '@/components/WorkOrderNoteModal'
import Modal from '@/components/Modal'

import { methods } from './keys/methods'
import { data } from './keys/data'

export default {
  name: 'WorkOrderNotes',

  components: {
    PageContentLayoutOnly,
    ModernTable,
    NotesModal,
    Modal
  },

  data,
  methods,

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    })
  },

  watch: {
    noteToggle() {
      if (this.noteToggle == false) {
        this.reload()
        this.noteToggle = false
        if (this.Modal && this.Modal != undefined) {
          this.Modal.$emit('update:toggle', (this.toggle = false))
        }
      }
    }
  },

  mounted() {
    this.reload()
  },

  i18n: {
    messages: {
      en: { workOrderNotes: { title: 'Notes' } }
    }
  }
}
</script>

<style></style>
